<pg-header boxed="true">
  <div class="header-inner header-md-height d-print-none">
    <a
      href="javascript:void(0)"
      class="btn-link toggle-sidebar d-lg-none pg pg-menu"
      (click)="toggleHorizontalMenuMobile()"
    >
    </a>
    <div class="">
      <div class="col-md-auto d-lg-none">
        <!--<img src="assets/img/logo/i3rsr32.png" alt="" width="51" height="32" />-->
        <img src="assets/img/logo/saferec.png" alt="" width="75" height="75" />
      </div>
      <ul
        class="d-lg-inline-block d-none notification-list no-margin d-lg-inline-block b-grey b-l b-r no-style p-l-0 p-r-20"
      >
        <li class="inline" style="margin-top:85px;">
          <app-site-name-logo [homeClick]="true"></app-site-name-logo>
        </li>
      </ul>
    </div>
    <div
      class="col-auto d-md-none d-flex float-right p-r-10"
      style="width:100%;"
    >
      <div style="width:100%;" class="m-t-20">
        <span class="bold text-right fs-14 font-heading ">{{
          authService.getUserId(true)
        }}</span>
        <!--<br *ngIf="authService.isUserDataAs()" >-->
        <span
          class="fs-14 bold text-right font-heading text-warning"
          *ngIf="authService.isUserDataAs()"
          ><br />{{ authService.userDataAs.client }}</span
        >
        <br />
        <app-site-lang [siteMenu]="true"></app-site-lang>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <!-- START User Info-->
      <div class="overflow-ellipsis" style="width:350px">
        <div class="pull-right p-r-10 fs-14 font-heading d-lg-block d-none">
          <span class="semi-bold">{{ authService.getUserEmail() }} : </span>
          <span class="bold">{{ authService.getUserId(true) }}</span>
        </div>
        <!--<div class="pull-right p-r-10 fs-14 font-heading d-lg-block d-none">-->
        <!---->
        <!--</div>-->
        <div *ngIf="authService.isUserDataAs()">
          <br />
          <div
            class="pull-right p-r-10 fs-14 font-heading d-lg-block d-none text-warning"
          >
            <!--{{authService.userDataAs.CORP 'Corp:' |'Ind:'}}-->
            <span class="semi-bold small-text "
              >{{ authService.userDataAs.name }} :
            </span>
            <span class="bold">{{ authService.userDataAs.client }}</span>
          </div>
          <!--<div class="pull-right p-r-10 fs-14 font-heading d-lg-block d-none text-warning">-->
          <!--</div>-->
        </div>
      </div>

      <div class="dropdown pull-right d-lg-block d-none" dropdown>
        <button
          class="profile-dropdown-toggle"
          type="button"
          dropdownToggle
          id="profileDropdown"
        >
          <span class="thumbnail-wrapper d39 circular inline userImg">
            <!--<img src="assets/img/profiles/avatar.jpg" alt="" pgRetina src1x="assets/img/profiles/avatar.jpg" src2x="assets/img/profiles/avatar_small2x.jpg" width="32" height="32">-->
            <img
              [src]="authService.getUserProfilePic()"
              alt=""
              width="50"
              height="50"
              style="background-color:white;"
              class="cursorHP"
            />
          </span>
        </button>
        <div
          class="dropdown-menu dropdown-menu-right profile-dropdown"
          *dropdownMenu
          role="menu"
        >
          <!--<a href="javascript:void(0)" class="dropdown-item"><i class="fs-13 pg pg-settings_small"></i> Settings</a>-->
          <!--<a href="javascript:void(0)" class="dropdown-item"><i class="fs-13 pg pg-outdent"></i> Feedback</a>-->
          <a
            href="javascript:void(0)"
            class="dropdown-item"
            *ngIf="authService.isUserDataAs()"
            (click)="authService.logoutAs(true)"
          >
            <span class="pull-left" (click)="authService.logoutAs(true)">{{
              authService.userDataAs.client
            }}</span>
            <span class="pull-right" (click)="authService.logoutAs(true)"
              ><i
                class="fs-13 pg pg-minus_circle"
                (click)="authService.logout(true)"
              ></i
            ></span>
          </a>
          <a
            href="javascript:void(0)"
            class="clearfix bg-master-lighter dropdown-item"
            (click)="authService.logout()"
          >
            <span class="pull-left" (click)="authService.logout()">{{
              "15" | translate
            }}</span>
            <span class="pull-right" (click)="authService.logout()"
              ><i class="fs-13 pg pg-power" (click)="authService.logout()"></i
            ></span>
          </a>
        </div>
      </div>
      <div style="width:40px; margin-top:50px">
        <app-site-lang></app-site-lang>
      </div>

      <!-- END User Info-->
      <!--<a href="javascript:void(0)" class="header-icon pg pg-alt_menu btn-link m-l-10 sm-no-margin d-inline-block" (click)="openQuickView($event)"></a>-->
    </div>
  </div>
  <!--<div class="header-inner justify-content-start header-lg-height title-bar m-t-0 p-b-5 ">-->
  <div class="navMargin" *ngIf="!authService.isMobileNav">
    <!--<div class="brand inline align-self-end">-->
    <!--<img src="assets/img/logo_s.png" alt="logo" pgRetina src1x="assets/img/logo_s.png" src2x="assets/img/logo_s_2x.png" width="17" height="20">-->
    <!--</div>-->
  </div>
  <pg-horizontal-menu [Items]="menuItems" HideExtra="4">
    <ng-template #mobileSidebarFooter>
      <!--<a href="javascript:void(0)" class="search-link d-flex justify-content-between align-items-center d-lg-none" (click)="openSearch($event)">Tap here to search <i class="pg pg-search float-right"></i></a>-->
    </ng-template>
  </pg-horizontal-menu>
</pg-header>
<h3
  class="text-danger m-0 p-0 p-l-10 p-r-10 d-print-none"
  *ngIf="authService.isMobileNav"
>
  {{ _pageTitle | translate }}
</h3>
<div class="page-container">
  <!-- START PAGE CONTENT WRAPPER -->
  <div class="page-content-wrapper {{ _pageContainerClass }}">
    <!-- START PAGE CONTENT -->
    <div class="content {{ _contentClass }}">
      <router-outlet></router-outlet>
    </div>
    <!-- END PAGE CONTENT -->
    <!-- START COPYRIGHT -->
    <!-- START CONTAINER FLUID -->
    <ng-template [ngIf]="_footer">
      <app-footer></app-footer>
    </ng-template>
    <!-- END COPYRIGHT -->
  </div>
  <!-- END PAGE CONTENT WRAPPER -->
</div>
<!-- END PAGE CONTAINER -->
